import { useProgress } from '@react-three/drei';

export default function useSafeUseProgress() {
  const { active, loaded, total, progress, errors } = useProgress();

  const isBroken = loaded > total;
  const isStuck = active && (isBroken || errors.length > 0);

  const safeActive = isStuck ? false : active;
  const safeProgress = isFinite(progress) ? progress : 100;

  return { safeActive, safeProgress };
}
